import React from "react";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import GetFlaggedDescriptions from "./get-flagged-descriptions";
import AddFlaggedDescription from "./add-flagged-description";
import GetUsersBanned from "./get-users-banned";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import i18n from "../../../constants/i18n";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title";
import getCorePopUpStore from "../../../stores/core/core-popup-store";

const FlaggedDescriptions = withLiteObserverAndTheme(() => {
  React.useEffect(() => {
    getCoreHistoryStore().setPageName(
      "SUPERVISOR_FLAGGED_DESCRIPTIONS",
      "SUPERVISOR_FLAGGED_DESCRIPTIONS"
    );
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("FLAGGED_DESCRIPTIONS")}
        subTitle={i18n.get("GET_FLAGGED_DESCRIPTIONS")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />

      <GetFlaggedDescriptions />
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <Et3PageTitle
        title={i18n.get("FLAGGED_DESCRIPTIONS")}
        subTitle={i18n.get("ADD_FLAGGED_DESCRIPTION")}
        withRefresh={false}
        withHelper={true}
        onPress={() => {
          getCorePopUpStore().showHelperMessage(
            "ADD_FLAGGED_DESCRIPTION_INVALID_INPUT"
          );
        }}
      />
      <AddFlaggedDescription />
      <Et3Margin top={15} bottom={0} left={0} right={0} />
      <Et3PageTitle
        title={i18n.get("FLAGGED_DESCRIPTIONS")}
        subTitle={i18n.get("GET_USER_BANNED")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <GetUsersBanned />
    </ET3PageDiv>
  );
});
export default FlaggedDescriptions;
